export type MediaFaqCategory =
  | "getting-started"
  | "media-production"
  | "visibility-results"
  | "ownership-control"
  | "general";

export interface MediaFaqItem {
  id: string;
  question: string;
  answer: string;
}

export interface MediaFaqCategoryTab {
  id: MediaFaqCategory;
  label: string;
}

export const mediaFaqCategories: MediaFaqCategoryTab[] = [
  { id: "getting-started", label: "Getting Started" },
  { id: "media-production", label: "Media & Production" },
  { id: "visibility-results", label: "Visibility & Results" },
  { id: "ownership-control", label: "Ownership & Control" },
  { id: "general", label: "General" },
];

export const mediaFaqItems: Record<MediaFaqCategory, MediaFaqItem[]> = {
  "getting-started": [
    {
      id: "gs-1",
      question: "How do I list my property on Krent?",
      answer:
        "Submit the form on this page. A Krent Advisor will contact you within 12 hours to guide you through the next steps.",
    },
    {
      id: "gs-2",
      question: "What happens after I submit the form?",
      answer:
        "A Krent Advisor will review your property details, recommend the right package, and schedule a visit to your property before anything goes live.",
    },
    {
      id: "gs-3",
      question: "What types of properties qualify?",
      answer:
        "Apartments, duplexes, shortlets, commercial spaces, office spaces, retail units, and estate developments. If you are unsure whether your property qualifies, your Krent Advisor will confirm during the consultation.",
    },
    {
      id: "gs-4",
      question:
        "How long does the whole process take from form submission to going live?",
      answer:
        "Apartments, duplexes, shortlets, commercial spaces, office spaces, retail units, and estate developments. If you are unsure whether your property qualifies, your Krent Advisor will confirm during the consultation.",
    },
  ],
  "media-production": [
    {
      id: "mp-1",
      question: "Who shoots my property?",
      answer:
        "Our in-house media team handles everything. You do not need to source a photographer or videographer separately.",
    },
    {
      id: "mp-2",
      question: "How long does the shoot take?",
      answer:
        "Most shoots are completed in a single visit. Your Krent Advisor will give you a specific timeframe based on your property size.",
    },
    {
      id: "mp-3",
      question: "What is the difference between Standard and Premium packages?",
      answer:
        "Standard is a clean, professional walkthrough video that presents your property attractively. Premium is a full cinematic production with drone footage, professional lighting, and high-end editing. See the difference here.",
    },
    {
      id: "mp-4",
      question: "Do I keep the media assets?",
      answer:
        "Yes. All photos, videos, and 3D tour content belong to you and can be used for your own marketing beyond Krent.",
    },
  ],
  "visibility-results": [
    {
      id: "vr-1",
      question: "Who sees my property?",
      answer:
        "Your property is distributed across the Krent platform, social media, and targeted paid campaigns on Meta and Google, reaching people actively searching for properties to rent, buy, or invest in.",
    },
    {
      id: "vr-2",
      question: "How will I know the campaign is working?",
      answer:
        "You receive a performance report showing enquiries, and leads. Premium package owners receive enhanced reporting with deeper insights.",
    },
    {
      id: "vr-3",
      question: "How quickly will I start receiving enquiries?",
      answer:
        "Most properties receive their first qualified enquiries within the first week of going live. Your Krent Advisor will give you a realistic projection based on comparable properties in your area.",
    },
    {
      id: "vr-4",
      question: "Are the people who enquire about my property verified?",
      answer:
        "Yes. All guests and tenants on Krent go through a KYC verification process before they are connected to any property.",
    },
  ],
  "ownership-control": [
    {
      id: "oc-1",
      question: "Does Krent take ownership of my property?",
      answer:
        "No. You remain the full owner at all times. Krent manages marketing, visibility, and tenant or buyer sourcing on your behalf.",
    },
    {
      id: "oc-2",
      question: "Can I block dates when I do not want the property available? ",
      answer:
        "Yes. Your calendar is fully within your control and can be updated at any time.",
    },
    {
      id: "oc-3",
      question: "What if I already have an agent or am listed elsewhere?",
      answer:
        "Speak to your Krent Advisor about this. Depending on your situation, a co-management or exclusive arrangement may work better. Your Krent Advisor will be honest about what delivers the best results for your property.",
    },
    {
      id: "oc-4",
      question: "What if a guest damages my property?",
      answer:
        "Krent holds and manages the caution fee on your behalf. Any damages are documented and deducted before the refund is processed. You do not chase anyone.",
    },
  ],
  general: [
    {
      id: "gn-1",
      question: "How much do the packages cost?",
      answer:
        "Pricing is confirmed during the Krent Advisor consultation because it depends on your property type, location, and goals. We will give you a clear figure before anything is agreed.",
    },
    {
      id: "gn-2",
      question: "Are there extra fees?",
      answer:
        "No. Everything is stated in the agreement before the process begins.",
    },
    {
      id: "gn-3",
      question: "What areas do you cover?",
      answer:
        "We currently serve major cities across Nigeria, with strong coverage in Lagos and surrounding areas. Ask your advisor about availability for your specific location.",
    },
    {
      id: "gn-4",
      question: "I have more questions. How do I reach someone? ",
      answer:
        "Use the chat button on this page or call us directly at 09118008008. A Krent Krent Advisor is available to help.",
    },
  ],
};
